<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/Report/TransferBarcode'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label-required">ตัวแทนจำหน่าย:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reTbOriginAgentCode'"
                    :name="'reTbOriginAgentCode'"
                    :select2-options="reTbOriginAgentCodeOptions"
                    @selectChange="onOriginAgentCodeChange"
                    v-model="reTbOriginAgentCode"
                    ref="reTbOriginAgentCode"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label-required">ร้านค้า:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reTbDestinationShopCode'"
                    :name="'reTbDestinationShopCode'"
                    :select2-options="reTbDestinationShopCodeOptions"
                    v-model="reTbDestinationShopCode"
                  ></select2>
                </div>
              </div>

              <!-- <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"">
                <div class="form-group">
                  <label class="label"
                    >ชื่อร้านค้า(กรณีไม่มีรหัสร้านค้า):</label
                  >
                  <input
                    v-model="reTbDestinationShopName"
                    type="text"
                    class="form-control"
                    placeholder="กรุณาระบุชื่อร้านค้า(กรณีไม่มีรหัสร้านค้า)"
                  />
                </div>
              </div> -->

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>BARCODE:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reTbBarcode'"
                    :name="'reTbBarcode'"
                    :select2-options="reTbBarcodeOptions"
                    multiple
                    v-model="reTbBarcode"
                  ></select2> -->
                  <input
                    v-model="reTbBarcode"
                    type="text"
                    class="form-control"
                    placeholder="กรุณาระบุรหัส BARCODE (มีหลายรหัสให้คั่นด้วย , เช่น 12345,54321)"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>รหัสทรัพย์สิน(เบียร์สด):</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reTbDepartmentMaterialCode'"
                    :name="'reTbDepartmentMaterialCode'"
                    :select2-options="reTbDepartmentMaterialCodeOptions"
                    multiple
                    v-model="reTbDepartmentMaterialCode"
                  ></select2> -->
                  <treeselect
                    v-model="reTbDepartmentMaterialCode"
                    :multiple="true"
                    :load-options="LoadreTbDepartmentMaterialCodeOptions"
                    :async="true"
                    v-on:select="ClearAfterselect"
                    searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                    placeholder="กรุณาเลือก"
                    :cacheOptions="false"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ประเภทสินค้า:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reTbProductTypeId'"
                    :name="'reTbProductTypeIdOptions'"
                    :select2-options="reTbProductTypeIdOptions"
                    multiple
                    v-model="reTbProductTypeId"
                  ></select2> -->
                  <treeselect
                    v-model="reTbProductTypeId"
                    :multiple="true"
                    :options="reTbProductTypeIdOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>แบรนด์สินค้า:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reTbBrandId'"
                    :name="''"
                    :select2-options=""
                    multiple
                    v-model="reTbBrandId"
                  ></select2> -->
                  <treeselect
                    v-model="reTbBrandId"
                    :multiple="true"
                    :options="reTbBrandIdOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>สินค้า:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reTbAssetCode'"
                    :name="'reTbAssetCode'"
                    :select2-options="reTbAssetCodeOptions"
                    multiple
                    v-model="reTbAssetCode"
                  ></select2> -->
                  <treeselect
                    v-model="reTbAssetCode"
                    :multiple="true"
                    :options="reTbAssetCodeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>จำนวนวันคงค้าง:</label>
                  <input
                    v-model="reTbOccupiedDays"
                    type="number"
                    class="form-control"
                    placeholder="กรุณาระบุจำนวนวันคงค้าง"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>สถานะ:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reTbReturnStatus'"
                    :name="'reTbReturnStatus'"
                    :select2-options="reTbReturnStatusOptions"
                    v-model="reTbReturnStatus"
                  ></select2>
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">
                  Generate Report
                </button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right">
                <button
                  v-if="
                    this.$root.canShow(['AGENT_REPORT', 'SUB_AGENT_REPORT'])
                  "
                  class="btn btn-outline-primary"
                  @click="exportTransferBarcode"
                  type="submit"
                >
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->
          <hr />
          <!-- begin: Details -->
          <div v-if="reTbIsShowDetail" class="row">
            <div class="col-xl-12 col-lg-12 col-md-12 .col-sm-12 col-xs-12">
              <label>ชื่อตัวแทนจำหน่าย : </label>
              <span>{{ reTbAgentName }}</span>
            </div>

            <div class="col-xl-12 col-lg-12 col-md-12 .col-sm-12 col-xs-12">
              <label>ชื่อร้านค้า : </label>
              <span>{{ reTbShopName }}</span>
            </div>

            <div class="col-xl-12 col-lg-12 col-md-12 .col-sm-12 col-xs-12">
              <label>ประเภทร้านค้า : </label>
              <span>{{ reTbShopTypeName }}</span>
            </div>

            <div class="col-xl-12 col-lg-12 col-md-12 .col-sm-12 col-xs-12">
              <label>ที่อยู่ : </label>
              <span
                >{{ reTbAdress }} อำเภอ : {{ reTbAmphur }} จังหวัด :
                {{ reTbProvince }}</span
              >
            </div>

            <!-- <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                  <label>อำเภอ : </label>
                  <span>{{reTbAmphur}}</span>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                  <label>จังหวัด : </label>
                  <span>{{reTbProvince}}</span>
              </div> -->

            <div class="col-xl-12 col-lg-12 col-md-12 .col-sm-12 col-xs-12">
              <label>เบอร์โทร : </label>
              <span>{{ reTbTel }}</span>
            </div>

            <div class="col-xl-12 col-lg-12 col-md-12 .col-sm-12 col-xs-12">
              <label>ผู้ติดต่อ : </label>
              <span>{{ reTbContact }}</span>
            </div>
          </div>
          <!-- end: Details -->

          <!--begin: Table -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable display nowrap"
                id="stockCardTable"
                style="width:100%"
              >
                <thead>
                  <tr>
                    <th class="all text-right" colspan="12">
                      ข้อมูล ณ วันที่ {{ reTbDateReq }}
                    </th>
                  </tr>
                  <tr>
                    <th class="all text-center">ลำดับ</th>
                    <th class="all text-center">BARCODE</th>
                    <th class="all text-center">รหัสทรัพย์สิน(เบียร์สด)</th>
                    <th class="all text-center">ประเภทสินค้า</th>
                    <th class="all text-center">รหัสสินค้า</th>
                    <th class="all text-center">ชื่อสินค้า</th>
                    <th class="all text-center">แบรนด์สินค้า</th>
                    <th class="all text-center">จำนวนวันคงค้าง</th>
                    <th class="all text-center">วันที่รับสินค้า</th>
                    <th class="all text-center">วันที่คืน</th>
                    <th class="all text-center">สถานะ</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Table -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import DatatableWarning from "../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

export default {
  components: {
    select2,
    Treeselect,
  },
  data: function() {
    var self = this;

    return {
      reTbIsShowDetail: false,
      reTbIsSelectAgent: false,
      reTbIsInitial: true,
      reTbDateReq: null,
      reTbOriginAgentCode: null,
      reTbDestinationShopCode: null,
      reTbDestinationShopName: null,
      reTbBarcode: null,
      reTbDepartmentMaterialCode: [],
      reTbNFCCode: [],
      reTbProductTypeId: [],
      reTbAssetCode: [],
      reTbBrandId: [],
      reTbOccupiedDays: null,
      reTbReturnStatus: null,
      reTbAgentName: "",
      reTbShopName: "",
      reTbShopTypeName: "",
      reTbAdress: "",
      reTbAmphur: "",
      reTbProvince: "",
      reTbTel: "",
      reTbContact: "",

      reTbOriginAgentCodeOptions: {
        placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
        allowClear: true,
        ajax: {
          
          url: "/Api/Report/Select2Agent",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              province_id: [],
              department: [],
              AgentCodes: [],
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
        templateResult: function(data) {
          return data.text;
        },
        language: {
          noResults: function() {
            return "ไม่พบข้อมูลร้านค้า";
          },
        },
      },
      reTbDestinationShopCodeOptions: {
        placeholder: "กรุณาเลือกร้านค้า",
        allowClear: true,
        ajax: {
          url: "/Api/Shop/Select2ShopByAgent",
          data: function(params) {
            var query = {
              agentCode: self.reTbOriginAgentCode,
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      reTbDepartmentMaterialCodeOptions: [],
      // reTbDepartmentMaterialCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกรหัสสินทรัพย์",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Barcode/Select2DepartmentMaterial",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reTbNFCCodeOptions: [],
      // reTbNFCCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกNFC",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Barcode/Select2NFC",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reTbProductTypeIdOptions: [],
      // reTbProductTypeIdOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกประเภทสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductType/Select2ProductType",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reTbBrandIdOptions: [],
      // reTbBrandIdOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกแบรนด์สินค้า",
      //   ajax: {
      //     url: "/Api/ProductBrand/Select2SearchBrandExistProduct",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reTbAssetCodeOptions: [],
      // reTbAssetCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Product/Select2Product",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reTbReturnStatusOptions: {
        placeholder: "กรุณาเลือกสถานะ",
        allowClear: true,
        data: [
          {
            id: "ยังไม่ได้ส่งคืน",
            text: "ยังไม่ได้ส่งคืน",
          },
          {
            id: "ส่งคืนแล้ว",
            text: "ส่งคืนแล้ว",
          },
        ],
      },
    };
  },
  computed: {},
  methods: {
    formReset: function(e) {
      let self = this;

      self.reTbOriginAgentCode = null;
      self.reTbDestinationShopCode = null;
      self.reTbDestinationShopName = null;
      self.reTbBarcode = null;
      self.reTbDepartmentMaterialCode = [];
      self.reTbNFCCode = [];
      self.reTbProductTypeId = [];
      self.reTbAssetCode = [];
      self.reTbBrandId = [];
      self.reTbOccupiedDays = null;
      self.reTbReturnStatus = null;

      $("#reTbOriginAgentCode")
        .empty()
        .trigger("change");

      $("#reTbDestinationShopCode")
        .empty()
        .trigger("change");

      $("#reTbBarcode")
        .val("")
        .trigger("change");

      $("#reTbDepartmentMaterialCode")
        .val("")
        .trigger("change");

      $("#reTbProductTypeId")
        .val("")
        .trigger("change");

      $("#reTbAssetCode")
        .val("")
        .trigger("change");

      $("#reTbBrandId")
        .val("")
        .trigger("change");

      $("#reTbReturnStatus")
        .val("")
        .trigger("change");

      self.initSelectedAgent();
    },
    formSubmit: function(e) {
      let self = this;

      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      if (!self.reTbDestinationShopCode && !self.reTbDestinationShopName) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกหรือระบุร้านค้า", "warning");
        return false;
      } else if (self.reTbDestinationShopCode && self.reTbDestinationShopName) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "กรุณาเลือกหรือระบุร้านค้าอย่างใดอย่างหนึ่ง",
          "warning"
        );
        return false;
      }

      e.preventDefault();
      var table = $("#stockCardTable").DataTable();
      table.draw();
    },
    onOriginAgentCodeChange: function(id, text, data, ref) {
      var self = this;

      self.reTbDestinationShopCode = null;
      $("#reTbDestinationShopCode")
        .empty()
        .trigger("change");
    },
    initSelectedAgent: function(e) {
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังดำเนินการ กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/Report/Select2Agent",
        data: {
          search: null,
          page: 1,
          province_id: [],
          department: [],
          AgentCodes: [],
        },
      })
        .then(function(response) {
          if (response.data != []) {
            self.$refs.reTbOriginAgentCode.setSelectedData({
              id: response.data.results[0].id,
              text: response.data.results[0].text,
            });
          } else {
            //Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }
        })
        .catch(function(error) {
          //Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    },
    exportTransferBarcode: function(e) {
      e.preventDefault();
      let self = this;

      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      if (!self.reTbDestinationShopCode && !self.reTbDestinationShopName) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกหรือระบุร้านค้า", "warning");
        return false;
      } else if (self.reTbDestinationShopCode && self.reTbDestinationShopName) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "กรุณาเลือกหรือระบุร้านค้าอย่างใดอย่างหนึ่ง",
          "warning"
        );
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/Report/ExportTransferBarcode",
        responseType: "arraybuffer",
        data: {
          IsInitial: self.reTbIsInitial,
          OriginAgentCode: self.reTbOriginAgentCode,
          DestinationShopCode: self.reTbDestinationShopCode,
          Barcode: self.reTbBarcode,
          DepartmentMaterialCode: self.reTbDepartmentMaterialCode,
          NFCCode: self.reTbNFCCode,
          ProductTypeId: self.reTbProductTypeId,
          AssetCode: self.reTbAssetCode,
          BrandId: self.reTbBrandId,
          OccupiedDays: self.reTbOccupiedDays,
          ReturnStatus: self.reTbReturnStatus,
        },
      })
        .then(function(response) {
          if (response.status == "200") {
            let filename = "";
            let contentType = response.headers["content-type"];
            let disposition = response.headers["content-disposition"];

            //===Get Filename===
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            }

            //Save file
            let blob = new Blob([response.data], { type: contentType });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = decodeURIComponent(filename);
            link.click();
          } else if (response.status == "204") {
            Swal.fire(
              "ไม่พบข้อมูล",
              "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
              "warning"
            );
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          //self.formReset();
          KTApp.unblockPage();
        });
    },
    LoadreTbDepartmentMaterialCodeOptions({ action, searchQuery, callback }) {
      var self = this;
      self.reTbDepartmentMaterialCodeOptions = [];
      if (action === ASYNC_SEARCH) {
        axios
          .get("/Api/Barcode/Select2DepartmentMaterial", {
            params: {
              page: 1,
              all: true,
              search: searchQuery,
            },
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.reTbDepartmentMaterialCodeOptions = [];
              data.forEach((element) => {
                self.reTbDepartmentMaterialCodeOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, self.reTbDepartmentMaterialCodeOptions);
          })
          .catch(function(error) {});
      }
    },
    LoadreTbNFCCodeOptions({ action, searchQuery, callback }) {
      var self = this;
      self.reTbNFCCodeOptions = [];
      if (action === ASYNC_SEARCH) {
        axios
          .get("/Api/Barcode/Select2NFC", {
            params: {
              page: 1,
              all: true,
              search: searchQuery,
            },
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.reTbNFCCodeOptions = [];
              data.forEach((element) => {
                self.reTbNFCCodeOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, self.reTbNFCCodeOptions);
          })
          .catch(function(error) {});
      }
    },
    LoadreTbProductTypeIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ProductType/Select2ProductType", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reTbProductTypeIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreTbBrandIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ProductBrand/Select2SearchBrandExistProduct", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reTbBrandIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreTbAssetCodeOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Product/Select2Product", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reTbAssetCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    ClearAfterselect: function(){
      $(`[class="vue-treeselect__input"]`).val("");
    }
  },
  async mounted() {
    let self = this;

    self.LoadreTbProductTypeIdOptions();
    self.LoadreTbBrandIdOptions();
    self.LoadreTbAssetCodeOptions();

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    self.reTbDateReq = moment().format("DD/MM/YYYY h:mm a");
    self.initSelectedAgent();

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#stockCardTable");
    //begin first table
    table
      .DataTable({
        autoWidth: true,
        scrollY: "100%",
        scrollX: true,
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/Report/TransferBarcode",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            self.reTbIsShowDetail = false;
            let jsonSearch = {
              IsInitial: self.reTbIsInitial,
              OriginAgentCode: self.reTbOriginAgentCode,
              DestinationShopCode: self.reTbDestinationShopCode,
              DestinationShopName: self.reTbDestinationShopName,
              Barcode: self.reTbBarcode,
              DepartmentMaterialCode: self.reTbDepartmentMaterialCode,
              NFCCode: self.reTbNFCCode,
              ProductTypeId: self.reTbProductTypeId,
              AssetCode: self.reTbAssetCode,
              BrandId: self.reTbBrandId,
              OccupiedDays: self.reTbOccupiedDays,
              ReturnStatus: self.reTbReturnStatus,
            };
            return JSON.stringify($.extend(d, jsonSearch));
          },
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
  			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [50, 100, 200, 500],

        pageLength: 100,

        language: {
          lengthMenu: "Display _MENU_",
        },
        // Order settings
        order: [[9, "desc"]],
        columns: [
          {
            data: "barcodeNo",
            className: "text-center",
            render: function(data, type, full, meta) {
              var t = table.DataTable();
              var page = t.page.info().start + 1;
              return page + meta.row;
            },
          },
          { data: "barcodeNoOld", className: "text-center" },
          { data: "departmentMaterialCode", className: "text-center" },
          { data: "productTypeName", className: "text-center" },
          { data: "assetCode", className: "text-center" },
          { data: "assetName", className: "text-center" },
          { data: "brandName", className: "text-center" },
          {
            data: "occupiedDays",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (data) return data + " วัน";
              else return "0 วัน";
            },
          },
          {
            data: "transactionDate",
            className: "text-center",
            render: function(data, type, full, meta) {
              return full.transactionDateString;
            },
          },
          { data: "returnTransactionDateString", className: "text-center" },
          {
            data: "returnStatus",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (data == "ส่งคืนแล้ว") {
                return '<span class="text-success"> ส่งคืนแล้ว</span>';
              } else if (data == "ยังไม่ได้ส่งคืน") {
                return '<span class="text-danger"> ยังไม่ได้ส่งคืน</span>';
              }
            },
          },
        ],
        drawCallback: function(settings) {
          self.reTbIsInitial = false;
          self.reTbDateReq = moment().format("DD/MM/YYYY h:mm a");

          if (settings.json.data.length > 0) {
            self.reTbIsShowDetail = true;

            var data = settings.json.data[0].details;
            self.reTbAgentName = data.agent;
            self.reTbShopName = (data.shopName2 == null || data.shopName2 == "") ? data.shop : data.shop + " (" + data.shopName2 + ")" ;
            self.reTbShopTypeName = data.shopType;
            self.reTbAdress = data.address;
            self.reTbAmphur = data.amphur;
            self.reTbProvince = data.province;
            self.reTbTel = data.tel;
            self.reTbContact = data.contactFullName;
          }
        },
      })
      .on("preXhr.dt", function() {
        KTApp.block(self.$refs.form, {
          showOverlay: false,
          opacity: 0.05,
          message: "กำลังค้นหาข้อมูล กรุณารอสักครู่...",
        });
      })
      .on("xhr.dt", function() {
        KTApp.unblock(self.$refs.form);
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("draw.dt", function() {
        // var t = table.DataTable();
        // var page = t.page.info().start + 1;
        // t.column(0, {}).nodes().each( function (cell, i) {
        //     cell.innerHTML = i+page;
        // } );
      });

    // set validation rules
    $(this.$refs.form).validate({
      rules: {
        reTbOriginAgentCode: "required",
      },
      messages: {
        reTbOriginAgentCode: "กรุณาเลือกตัวแทนจำหน่าย",
      },
    });

    $(this.$refs.form).validate().settings.ignore = ":hidden";
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Report/TransferBarcode.vue